import AdditionalQuestion from "./AdditionalQuestion"
import AdditionalQuestionGroup from "./AdditionalQuestionGroup"
import AdditionalQuestionMatrix from "./AdditionalQuestionMatrix"
const AdditionalQuestionContainer = ({
  entity,
  setEntity,
  errors,
  section,
  removeError,
  disabled,
  question,
  number,
  kind,
}) => {
  if (kind === "additional") {
    return (
      <AdditionalQuestion
        entity={entity}
        setEntity={setEntity}
        errors={errors}
        section={section}
        removeError={removeError}
        disabled={disabled}
        question={question}
        number={number}
        alignment={1}
      />
    )
  }
  if (kind === "group") {
    return (
      <div style={{ marginTop: "1rem", marginLeft: "1rem", width: "100%" }}>
        <AdditionalQuestionGroup
          disabled={disabled}
          entity={entity}
          errors={errors}
          group={question}
          removeError={removeError}
          setEntity={setEntity}
        />
      </div>
    )
  }
  if (kind === "matrix") {
    return (
      <AdditionalQuestionMatrix
        question={question}
        disabled={disabled}
        entity={entity}
        errors={errors}
        removeError={removeError}
        setEntity={setEntity}
      />
    )
  }
}
export default AdditionalQuestionContainer
